<header app-nav></header>
@if (adsenseService.adBlockedIsActive()) {
  <app-ad-blocker-detection></app-ad-blocker-detection>
} @else {
  <ngx-loading-bar
    color="#0066ff"
    height="3px"
    style="z-index: 100000000000000000000000000000"
  ></ngx-loading-bar>
  <ngx-spinner type="ball-scale-multiple">
    <p style="color: white" id="spinner-text">
      {{ "Processing ..." | translate | async }}
    </p>

    <div
      class="progress"
      style="height: 20px"
      [hidden]="!(spinner?.progressPercent | async)"
    >
      <div
        class="progress-bar"
        [ngStyle]="{ width: (spinner?.progressPercent | async) + '%' }"
        [ngClass]="{ 'bg-success': (spinner?.progressPercent | async) == 100 }"
      >
        <span *ngIf="((spinner?.progressPercent | async) || 0) < 100">{{
          (spinner.progressPercent | async) + "%"
        }}</span>
        <span
          *ngIf="(spinner.progressPercent | async) === 100"
          translate="The file has been downloaded and is currently being processed."
        ></span>
      </div>
    </div>
  </ngx-spinner>

  <router-outlet></router-outlet>
  <app-go-top-button></app-go-top-button>
}

@defer {
  <app-auth-modal
    *ngIf="authGuardService.showLoginModal()"
    (onClose)="authGuardService.showLoginModal.set(undefined)"
    loginDescription="You must log in to access this feature ... Please login and try again"
  ></app-auth-modal>
}

<footer [hidden]="!isAllowFooter()" app-footer></footer>
<app-cookie-banner></app-cookie-banner>
